angular.module('jv.Admin.CustomFormField.directive', [])
.directive('jvCustomFormField', [
    '$compile', '$timeout',
    function($compile, $timeout) {
        var fieldToDirectiveMap = {
            name: 'jv-text-form-field',
            dropdown: 'jv-dropdown-form-field',
            phone: 'jv-text-form-field',
            text: 'jv-text-form-field',
            amount: 'jv-text-form-field',
            number: 'jv-text-form-field',
            date: 'jv-text-form-field',
            checkbox: 'jv-checkbox-form-field',
            radio: 'jv-radio-form-field',
            zip: 'jv-text-form-field',
            employee: 'jv-dropdown-form-field',
            employeenodefault:'jv-dropdown-form-field',
            hyperlink: 'jv-text-form-field',
            currency: 'jv-currency-form-field'
        };
        var elementToDirectiveMap = {
            heading: 'jv-heading-element',
            text: 'jv-text-element',
            divider: 'jv-divider-element'
        };
        return {
            restrict: 'A',
            scope: {
                field: '=jvCustomFormField',
                onDelete: '&',
                onChange: '&',
                editing: '='
            },
            link: function(scope, element, attributes, model) {
                var state = scope.state = {};
                var fieldType;
                var objectType = scope.field.objectType.toLowerCase();
                var directive = elementToDirectiveMap[objectType];
                scope.previewField = angular.copy(scope.field);
                var skipEditWatch;

                state.objectType = objectType;
                if (scope.field.fieldType) {
                    fieldType = scope.field.fieldType.toLowerCase();
                }
                if (!directive && fieldType) {
                    directive = fieldToDirectiveMap[fieldType];
                    state.isField = true;
                }

                if (directive) {
                    element.html($compile('<div '+ directive +' ng-mouseOver="hoverToggle(true)"  ng-mouseLeave="hoverToggle(false)" class="jv-form-field jv-form-field-' + fieldType + '"></div>')(scope));
                }

                // Don't allow first name, last name, or email to be deleted
                state.isRequired = (['-1', '-2', '-3'].indexOf(scope.field.fieldEId) !== -1);

                scope.hoverToggle = function(hovering) {
                    if (!state.editing && !scope.editing) {
                        state.hovered = hovering;
                    }
                };

                scope.delete = function() {
                    scope.doneEditing();
                    $timeout(function() {
                        scope.onDelete({ field: scope.field });
                        scope.onChange();
                    });
                };

                scope.edit = function() {
                    state.editing = true;
                    scope.editing = scope.field;
                    skipEditWatch = true;
                    scope.onChange();
                };

                scope.doneEditing = function() {
                    state.editing = false;
                    state.hovered = false;
                    scope.editing = null;
                    skipEditWatch = true;
                };

                scope.$watch('editing', function(field) {
                    var shouldEdit;
                    if (field && !skipEditWatch) {
                        shouldEdit = (field && field === scope.field && !state.editing);
                        state.hovered = state.editing = shouldEdit;
                    }
                    skipEditWatch = false;
                });

                scope.isFieldEditable = function () {
                    const editableTypes = ["checkbox", "dropdown", "radio"];
                    return editableTypes.includes(fieldType);
                }
            }
        }
    }
])
.factory('createField', [
    '$templateCache',
    function($templateCache) {
        return function(preview, directive) {
            return angular.extend({
                restrict: 'A',
                template: function() {
                    return $templateCache.get('custom-form-field').replace(/__PREVIEW_PLACEHOLDER__/g, preview);
                },
            }, directive || {});
        }
    }
])
.directive('jvTextFormField', [
    'createField',
    function(createField) {
        return createField(
            '<div class="border-border padding-regular white-bg"></div>'
        );
    }
])
.directive('jvDropdownFormField', [
    'createField',
    function(createField) {
        return createField(
            '<select class="full-width"><option></option><option ng-repeat="value in field.values" value="{{ value.value }}">{{ value.value }}</option></select>'
        );
    }
])
.directive('jvCheckboxFormField', [
    'createField',
    function(createField) {
        return createField(
            '<div ng-repeat="value in field.values" class="margin-top-xx-small"><i class="icon icon-checkbox-blank dark-sec"></i> {{ value.value }}</div>'
        );
    }
])
.directive('jvRadioFormField', [
    'createField',
    function(createField) {
        return createField(
            '<div ng-repeat="value in field.values" class="margin-top-xx-small"><i class="icon icon-radio-empty dark-sec"></i> {{ value.value }}</div>'
        );
    }
])
.directive('jvHeadingElement', [
    'createField',
    function(createField) {
        return createField(
            '<div class="large margin-bottom-xx-small font-medium">{{ field.name }}</div>'
        );
    }
])
.directive('jvDividerElement', [
    'createField',
    function(createField) {
        return createField(
            '<div class="border-border-bottom margin-top-small margin-bottom-small"></div>'
        );
    }
])
.directive('jvTextElement', [
    'createField',
    function(createField) {
        return createField(
            '<div class="margin-bottom-xx-small">{{ field.name }}</div>'
        );
    }
])
.directive('jvCurrencyFormField', [
    'createField',
    function(createField) {
        return createField(
          '<div ng-model="previewField.value" jv-currency-cleave="cleaveNum" jv-currency-cleave-changed = "cleaveValueChanged" jv-currency-apply-field="previewField" disabled></div>'
        );
    }
]);
